module.exports = __webpack_public_path__ + "media/images/sp/stores/kyoto/kyoto_sns_04-a4b2c339ad4d6f1fb677e1fe1da0655a.jpg";